const getters = {
    taxs: (state) => state.taxs,
    id: (state) => state.taxId,
    loading: state => state.loading
};

export default getters;

